import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {GetBreweriesDTO} from 'typescript/dto/BreweriesDto';
import Brewery from 'typescript/models/Brewery';
import PubPage from 'typescript/models/PubPage';

interface IState {
  breweries: {list: Brewery[]; totalCount: number; totalPages: number};
  breweryPubs: PubPage[];
  filters: GetBreweriesDTO;
  checkedBreweryTypes: string[];
}

export const breweriesPerPage = 15;

const initialState: IState = {
  breweries: {list: [], totalPages: 0, totalCount: 0},
  breweryPubs: [],
  filters: {page: 1, perPage: breweriesPerPage, name: '', direction: 'asc', column: 'name'},
  checkedBreweryTypes: [],
};

export const breweriesNamespace = 'breweries';

const breweriesSlice = createSlice({
  name: breweriesNamespace,
  initialState,
  reducers: {
    setBreweriesAC: (state, action: PayloadAction<Brewery[]>) => {
      state.breweries = {...state.breweries, list: action.payload};
    },
    setTotalPagesAC: (state, action: PayloadAction<{totalPages: number; totalCount: number}>) => {
      state.breweries = {
        ...state.breweries,
        totalPages: action.payload.totalPages,
        totalCount: action.payload.totalCount,
      };
    },
    setBreweryPubsAC: (state, action: PayloadAction<IState['breweryPubs']>) => {
      state.breweryPubs = action.payload;
    },
    setBreweryFiltersAC: (state, action: PayloadAction<IState['filters']>) => {
      state.filters = action.payload;
    },
    setCheckedBreweryTypesAC: (state, action: PayloadAction<IState['checkedBreweryTypes']>) => {
      state.checkedBreweryTypes = action.payload;
    },
  },
});

export default breweriesSlice;

export const {setCheckedBreweryTypesAC, setBreweryFiltersAC, setBreweriesAC, setTotalPagesAC, setBreweryPubsAC} =
  breweriesSlice.actions;
